(() => {
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     Marquee — build 2 identical groups for seamless loop
     ============================================================ */
  const marqueeBits = [
    'FREE SHIPPING OVER $35',
    '30-DAY HAPPINESS GUARANTEE',
    'SHIPS IN 1-2 BUSINESS DAYS',
    'MADE FOR FAMILIES',
  ];
  const buildMarquee = (el) => {
    el.innerHTML = marqueeBits.map(b => `<span>${b}</span><span class="star">★</span>`).join('');
  };
  buildMarquee(document.getElementById('marquee-group-1'));
  buildMarquee(document.getElementById('marquee-group-2'));

  /* ============================================================
     Header sticky shadow
     ============================================================ */
  const header = document.getElementById('site-header');
  const onScroll = () => header.classList.toggle('stuck', window.scrollY > 4);
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ============================================================
     Hero sun parallax (subtle)
     ============================================================ */
  if (!REDUCED) {
    const sun = document.getElementById('hero-sun');
    let ticking = false;
    const update = () => {
      const y = Math.min(window.scrollY, 600);
      sun.style.transform = `translateX(-50%) translateY(${y * 0.18}px)`;
      ticking = false;
    };
    addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ============================================================
     Product stack: subtle 3D mouse tilt
     ============================================================ */
  if (!REDUCED) {
    const stack = document.getElementById('product-stack');
    const box = document.getElementById('stack-box');
    stack.addEventListener('mousemove', (e) => {
      const r = stack.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      box.style.transform = `perspective(800px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg)`;
    });
    stack.addEventListener('mouseleave', () => {
      box.style.transform = '';
    });
  }

  /* ============================================================
     Quantity stepper + price update + flash
     ============================================================ */
  const PRICE = 24.99;
  const qtyValEl = document.getElementById('qty-val');
  const heroTotalEl = document.getElementById('hero-total');
  const heroPriceEl = document.getElementById('hero-price');
  const finalPriceEl = document.getElementById('final-price');
  const mobilePriceEl = document.getElementById('mobile-price');
  finalPriceEl.textContent = `$${PRICE.toFixed(2)}`;
  mobilePriceEl.textContent = `$${PRICE.toFixed(2)}`;
  let qty = 1;
  const updateTotal = () => {
    qtyValEl.textContent = qty;
    heroTotalEl.textContent = `$${(PRICE * qty).toFixed(2)}`;
    heroPriceEl.classList.add('is-flash');
    setTimeout(() => heroPriceEl.classList.remove('is-flash'), 280);
  };
  document.getElementById('qty-minus').addEventListener('click', () => { qty = Math.max(1, qty - 1); updateTotal(); });
  document.getElementById('qty-plus').addEventListener('click', () => { qty += 1; updateTotal(); });

  /* ============================================================
     Cart state
     ============================================================ */
  const FREE_SHIP = 35;
  let cart = [];
  const cartCountEl = document.getElementById('cart-count');
  const cartItemsEl = document.getElementById('cart-items');
  const cartEmptyEl = document.getElementById('cart-empty');
  const cartFootEl = document.getElementById('cart-foot');
  const cartSubEl = document.getElementById('cart-subtotal');
  const checkoutAmtEl = document.getElementById('checkout-amount');
  const shipMsgEl = document.getElementById('ship-msg');
  const shipBarEl = document.getElementById('ship-bar');

  const renderCart = () => {
    const count = cart.reduce((s, it) => s + it.qty, 0);
    const subtotal = cart.reduce((s, it) => s + it.qty * it.price, 0);
    cartCountEl.textContent = count;
    cartCountEl.classList.add('bump');
    setTimeout(() => cartCountEl.classList.remove('bump'), 260);

    if (cart.length === 0) {
      cartEmptyEl.style.display = '';
      cartFootEl.hidden = true;
      cartItemsEl.innerHTML = '';
      cartItemsEl.appendChild(cartEmptyEl);
    } else {
      cartEmptyEl.style.display = 'none';
      cartFootEl.hidden = false;
      cartItemsEl.innerHTML = '';
      cart.forEach((it, i) => {
        const el = document.createElement('div');
        el.className = 'drawer__item';
        el.innerHTML = `
          <img src="${it.image}" alt="${it.name}"/>
          <div class="drawer__item-body">
            <div class="drawer__item-name">${it.name}</div>
            <div class="drawer__item-price">$${it.price.toFixed(2)} each</div>
            <div class="drawer__item-controls">
              <div class="drawer__item-stepper">
                <button data-dec="${i}" aria-label="Decrease"><svg width="12" height="12"><use href="#i-minus"/></svg></button>
                <span class="qv">${it.qty}</span>
                <button data-inc="${i}" aria-label="Increase"><svg width="12" height="12"><use href="#i-plus"/></svg></button>
              </div>
              <button class="drawer__item-remove" data-rm="${i}">Remove</button>
            </div>
          </div>
          <div class="drawer__item-total">$${(it.price * it.qty).toFixed(2)}</div>
        `;
        cartItemsEl.appendChild(el);
      });
    }
    cartSubEl.textContent = `$${subtotal.toFixed(2)}`;
    checkoutAmtEl.textContent = `$${subtotal.toFixed(2)}`;

    const remaining = Math.max(0, FREE_SHIP - subtotal);
    const prevUnlocked = parseFloat(shipBarEl.style.width || '0') >= 100;
    const progress = Math.min(100, (subtotal / FREE_SHIP) * 100);
    shipBarEl.style.width = `${progress}%`;
    if (remaining > 0) {
      shipMsgEl.innerHTML = `You're <b>$${remaining.toFixed(2)}</b> away from <b style="color:var(--green-deep)">free shipping</b> 🚚`;
    } else {
      shipMsgEl.innerHTML = `<b style="color:var(--green-deep)">🎉 You unlocked free shipping!</b>`;
      if (!prevUnlocked) burstConfetti();
    }
  };

  cartItemsEl.addEventListener('click', (e) => {
    const t = e.target.closest('button'); if (!t) return;
    if (t.dataset.inc !== undefined) { cart[+t.dataset.inc].qty++; renderCart(); }
    else if (t.dataset.dec !== undefined) {
      const i = +t.dataset.dec; cart[i].qty = Math.max(1, cart[i].qty - 1); renderCart();
    }
    else if (t.dataset.rm !== undefined) { cart.splice(+t.dataset.rm, 1); renderCart(); }
  });

  const addToCart = () => {
    const existing = cart.find(it => it.id === 'wwa-base');
    if (existing) existing.qty += qty;
    else {
      const boxImg = document.querySelector('#stack-box img');
      const boxSrc = boxImg ? boxImg.src : '';
      cart.push({ id: 'wwa-base', name: 'Wild Wild Avocado · Card Game', price: PRICE, qty, image: boxSrc });
    }
    renderCart();
    openCart();
    showToast(`Added ${qty} to cart`);
  };

  document.getElementById('add-to-cart').addEventListener('click', addToCart);
  document.getElementById('final-cta').addEventListener('click', addToCart);
  document.getElementById('mobile-add').addEventListener('click', addToCart);

  /* ============================================================
     Cart drawer open/close
     ============================================================ */
  const scrim = document.getElementById('cart-scrim');
  const drawer = document.getElementById('cart-drawer');
  const openCart = () => { scrim.classList.add('open'); drawer.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const closeCart = () => { scrim.classList.remove('open'); drawer.classList.remove('open'); document.body.style.overflow = ''; };
  document.getElementById('cart-open').addEventListener('click', openCart);
  document.getElementById('cart-close').addEventListener('click', closeCart);
  document.getElementById('cart-start').addEventListener('click', closeCart);
  scrim.addEventListener('click', closeCart);
  addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });
  document.getElementById('checkout-btn').addEventListener('click', () => {
    showToast('Going to checkout…');
  });
  renderCart();

  /* ============================================================
     Toast
     ============================================================ */
  const toast = document.getElementById('toast');
  const toastMsg = document.getElementById('toast-msg');
  let toastTimer;
  const showToast = (msg) => {
    toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('show'), 2200);
  };

  /* ============================================================
     Menu carousel arrows
     ============================================================ */
  const track = document.getElementById('menu-track');
  document.getElementById('menu-prev').addEventListener('click', () => track.scrollBy({ left: -320, behavior: 'smooth' }));
  document.getElementById('menu-next').addEventListener('click', () => track.scrollBy({ left: 320, behavior: 'smooth' }));

  /* ============================================================
     FAQ accordion (single-open)
     ============================================================ */
  document.getElementById('faq-list').addEventListener('click', (e) => {
    const q = e.target.closest('.faq__q'); if (!q) return;
    const item = q.parentElement;
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq__item.open').forEach(it => it.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  });

  /* ============================================================
     Newsletter form
     ============================================================ */
  const newsForm = document.getElementById('news-form');
  newsForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const wrap = newsForm.parentElement;
    const success = document.createElement('div');
    success.className = 'news-success';
    success.innerHTML = '🎉 You\'re in! Check your inbox.';
    newsForm.replaceWith(success);
    burstConfetti();
  });

  /* ============================================================
     Reveal-on-scroll (IntersectionObserver)
     ============================================================ */
  const reveals = document.querySelectorAll('[data-reveal]');
  const io = new IntersectionObserver((entries) => {
    entries.forEach(en => {
      if (en.isIntersecting) {
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  reveals.forEach(el => io.observe(el));

  /* ============================================================
     Stat counters (tick from 0 → target on first scroll-in)
     ============================================================ */
  const counters = document.querySelectorAll('[data-count-to]');
  const counterIO = new IntersectionObserver((entries) => {
    entries.forEach(en => {
      if (en.isIntersecting) {
        const el = en.target;
        const target = parseFloat(el.dataset.countTo);
        const decimals = parseInt(el.dataset.countDecimals || '0', 10);
        const prefix = el.dataset.countPrefix || '';
        const suffix = el.dataset.countSuffix || '';
        const dur = 1100;
        const t0 = performance.now();
        const step = (t) => {
          const p = Math.min(1, (t - t0) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          const v = target * eased;
          el.textContent = prefix + (decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString()) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = prefix + (decimals ? target.toFixed(decimals) : Math.round(target).toLocaleString()) + suffix;
        };
        if (REDUCED) {
          el.textContent = prefix + (decimals ? target.toFixed(decimals) : Math.round(target).toLocaleString()) + suffix;
        } else {
          requestAnimationFrame(step);
        }
        counterIO.unobserve(el);
      }
    });
  }, { threshold: 0.4 });
  counters.forEach(el => counterIO.observe(el));

  /* ============================================================
     Magnetic buttons (subtle pull toward cursor when within 80px)
     ============================================================ */
  if (!REDUCED && matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-magnetic]').forEach(btn => {
      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        const dx = e.clientX - cx, dy = e.clientY - cy;
        const dist = Math.hypot(dx, dy);
        const max = Math.max(r.width, r.height);
        if (dist < max * 0.9) {
          btn.style.transform = `translate(${dx * 0.18}px, ${dy * 0.18}px)`;
        }
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* ============================================================
     Mobile sticky buy: show when hero buy box scrolls out
     ============================================================ */
  const buyBox = document.querySelector('.buy-box');
  const mobileBuy = document.getElementById('mobile-buy');
  if (buyBox && mobileBuy) {
    const buyIO = new IntersectionObserver((entries) => {
      const en = entries[0];
      mobileBuy.classList.toggle('show', !en.isIntersecting);
    }, { threshold: 0 });
    buyIO.observe(buyBox);
  }

  /* ============================================================
     Cursor sparkle trail (desktop, throttled)
     ============================================================ */
  if (!REDUCED && matchMedia('(pointer: fine)').matches) {
    const colors = ['var(--pink)', 'var(--yellow)', 'var(--mint)', 'var(--lilac)'];
    let last = 0;
    addEventListener('mousemove', (e) => {
      const now = performance.now();
      if (now - last < 90) return;
      last = now;
      const span = document.createElement('span');
      span.className = 'cursor-spark';
      span.style.left = e.clientX + 'px';
      span.style.top = e.clientY + 'px';
      span.style.color = colors[Math.floor(Math.random() * colors.length)];
      span.innerHTML = '<svg width="14" height="14"><use href="#i-sparkle"/></svg>';
      document.body.appendChild(span);
      setTimeout(() => span.remove(), 700);
    });
  }

  /* ============================================================
     Confetti burst (used on free-shipping unlock + newsletter)
     ============================================================ */
  function burstConfetti() {
    if (REDUCED) return;
    const host = document.getElementById('confetti-burst');
    const colors = ['var(--pink)', 'var(--yellow)', 'var(--mint)', 'var(--lilac)', 'var(--peach)', 'var(--green)'];
    const N = 60;
    for (let i = 0; i < N; i++) {
      const piece = document.createElement('span');
      piece.className = 'confetti-piece';
      const left = Math.random() * 100;
      piece.style.left = left + 'vw';
      piece.style.background = colors[i % colors.length];
      piece.style.border = '2px solid var(--brown)';
      piece.style.borderRadius = (Math.random() > 0.5 ? '4px' : '999px');
      piece.style.setProperty('--cx', (Math.random() * 200 - 100) + 'px');
      piece.style.setProperty('--cx-end', (Math.random() * 200 - 100) + 'px');
      piece.style.setProperty('--cr', (Math.random() * 1440) + 'deg');
      piece.style.animationDelay = (Math.random() * 200) + 'ms';
      host.appendChild(piece);
      setTimeout(() => piece.remove(), 1900);
    }
  }

  /* ============================================================
     Smooth-scroll for nav (offset to account for sticky header)
     ============================================================ */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (id === '#') return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      const rect = target.getBoundingClientRect();
      const offset = header.getBoundingClientRect().height + 8;
      window.scrollTo({ top: window.scrollY + rect.top - offset, behavior: REDUCED ? 'auto' : 'smooth' });
    });
  });

  /* ============================================================
     Easter egg: tap the avocado emoji 5x for a confetti party
     ============================================================ */
  let avoTaps = 0; let avoTimer;
  document.querySelectorAll('.values__item').forEach(el => {
    if (el.textContent.includes('🇺🇸')) return; // arbitrary skip
  });
  document.addEventListener('click', (e) => {
    if (e.target.classList && e.target.classList.contains('values__emoji')) {
      avoTaps++;
      clearTimeout(avoTimer);
      avoTimer = setTimeout(() => avoTaps = 0, 1200);
      if (avoTaps >= 5) {
        avoTaps = 0;
        burstConfetti();
        showToast('🥑 You found the avocado!');
      }
    }
  });

})();
